import { Directive, HostListener, ElementRef, OnInit } from "@angular/core";

@Directive({ selector: "[dkCurrencyInput]" })
export class DkCurrencyInputDirective implements OnInit {

    private el: HTMLInputElement;

    constructor(
        private elementRef: ElementRef
    ) {
        this.el = this.elementRef.nativeElement;
    }

    ngOnInit() {
    }

    @HostListener("keydown", ["$event"])
    onKeydown(event: KeyboardEvent) {
        // Allow: backspace, delete, tab, escape, and enter
        if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
            // Allow: Ctrl+A
            (event.keyCode == 65 && ((event.ctrlKey === true) || (event.metaKey === true))) ||
            // Allow: Ctrl+X
            (event.keyCode == 88 && ((event.ctrlKey === true) || (event.metaKey === true))) ||
            // Allow: Ctrl+C
            (event.keyCode == 67 && ((event.ctrlKey === true) || (event.metaKey === true))) ||
            // Allow: Ctrl+V
            (event.keyCode == 86 && ((event.ctrlKey === true) || (event.metaKey === true))) ||
            // Allow: . ,
            (event.keyCode == 188 || event.keyCode == 190 || event.keyCode == 110) ||
            // Allow: home, end, left, right
            (event.keyCode >= 35 && event.keyCode <= 39)) {
            // let it happen, don't do anything
            return true;
        }
        else {
            // Ensure that it is a number and stop the keypress
            if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                return false;
            }
        }
    }
}